import React from 'react';
import { t } from 'i18next';

class ErrorBoundary extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <h1>{t('errors.somethingWrong')}</h1>;
        }

        return this.props.children;
    }
}

export { ErrorBoundary };
